export default {
    zh: {
        overdueTaskCount: '过期任务数量',
        otherCount: '其他数量',
        borrowingCount: '意向借款数量',
        noBorrowingCount: '无借款意向数量',
        loanCount: '放款数',
        riskPassCount: '风控通过数',
        applyCount: '申请数',
        registerCount: '注册数',
        invalidCount: '无效号码数量',
        missedRejectedCount: '未接/拒接数量',
        notCallCount: '未拨打数量',
        conversionRatio: '转化比',
        callCount: '已拨打数量',
        taskCountTotal: '任务总数',
        dialDate: '拨打日期',
        dialNumber: '拨打号码',
        telemarketerName: '电销员名称',
        callStatus: '通话状态',
        depositDate: '存入日期',
        title: '催收管理',
        allTitle: '催收任务管理',
        mytitle: '我的催收任务',
        historytitle: '历史催收任务',
        performancetitle: '催收绩效',
        createTime: '入催时间',
        followNum: '跟进单数',
        followUserName: '跟进人',
        followResult: '跟进结果',
        followTime: '跟进时间',
        repaymentIntention: '还款意愿',
        collectionTaskStatus: '催收任务状态',
        batchReplacementFollowStaff: '批量更换跟进人员',
        transferOrder: '调单',
        userName: '催收人',
        mobile:'手机号',
        collectionNumber: '分单总数',
        collectionAmount: '分单金额',
        pendingNum: '待处理总数',
        processNum: '跟进中总数',
        cancelNum: '取消总数',
        succedNumber: '催回总数',
        followCount: '已处理总数',
        extendNumber: '展期数',
        succedAmount: '催回金额',
        succedRate: '催回成功率',
        paymentamt: '催回金额',
        naNum: '客户自主还款数',
        approval: '审批',
        endTime: '到期日',
        settleTime: '出催时间',
        firstOverdueCount: '1-3天回款总数',
        firstOverdueAmt: '1-3天回款金额',
        secOverdueCount: '4-7天回款总数',
        secOverdueAmt: '4-7天回款金额',
        thridOverdueCount: '8天以上回款总数',
        thridOverdueAmt: '8天以上回款金额',
        applyReductionAmt: '申请减免金额',
        balFee: '剩余滞纳金',
        countResult: '统计结果',
        countResultRate: '统计结果占比',
        userId: '催收员编号',
        userMobile: '催收员账号',
        userMobilePlaceholder: '请输入催收员账号',
        groupName: '催收分组',
        linkCondition: '通讯录和联系人情况',
        custContractCondition:'客户本人联系情况',
        amountSuccedRate: '催回成功率（金额）',
        ym: '日期',
        ifAmtRate: '占比',
        ifAmtFirstOverdueRate: '首逾率',
        ifAmtUnSettleRate: '坏账率',
        ifAmtEarlySettledRate: '提前结清率',
        ifAmtOverdueSettledRate: '逾期结清率',
        ifAmtExtendsionSettledRate: '展期结清率',
        ifAmtOverdueExtendsionSettledRate: '逾期展期结清率',
        ifAmtSettledRate: '正常结清率',
        ifLoanCount: '借款类型',
        operationTime: '操作时间',
        operationUserName: '操作人名称',
        operationUserMobile: '操作人账号',
        operationType: '操作类型',
        taskIdOld: '任务Id-老',
        taskIdNew: '任务Id-新',
        orderInfoId: '订单id',
        custInfoId: '客户编号',
        waitingForCollection: '待跟进',
        answeredByThemSelf: '本人接听',
        notInPerson: '非本人接听',
        noAnswer: '无人接听',
        emptyNumber: '空号',
        turnedOff: '关机',
        unavailable: '停机',
        whatsappPromisesToPayBackOnTime: 'Whatsapp承诺准时还款',
        WhatsappDidNotReply: 'Whatsapp未回复',
        NoTieneCuentaDeWhatsapp: '没有whatsapp账号',
        haveAWishAndCanReturnTheLoan: '有意愿有能力还款',
        haveAWishButCantReturnTheLoan: `有意愿还款但无能力还款`,
        canReturnTheLoanButRefuseToPayIt: '有能力但拒绝还款',
        canReturnTheLoanButWantToConsult: '有能力但需协商',
        cantJudgeItForNow: `暂无法判定`,
        LaPersonaDeContactoPuedeComunicarleAlClienteParaElReembolso: '联系人可以通知客户还款',
        ElContactoNoPuedeComunicarse: '联系人无法沟通',
        LaInformaciónDelContactoEsFalsa: '通讯录联系人信息造假',
        createdTime: '生成时间',
        id: 'ID',
        remark: '描述',
        postTime: '分单时间',
        isFollow: '是否跟进',

        diffAmt: '差额',
        diffAvgAmt: '与平均催回差距（金额）',
        diffFirstAmt: '与催回率第一组差距（金额）',
        isRegist: '是否注册',
        isApply: '是否申请',
        isAudit: '是否通过',
        endDate: '到期时间',
        countDays: '统计天数',
        countDaysPlaceholder: '请选择统计天数',
        statisticalPeriod: '统计周期',
        viewField: '展示字段',
        groupName: '组名',
        collectionLevel: '催收阶段',
        collectionLoginName: '催收登录账号名称',
        collectionLoginNo: '催收登录账号',
        locationStatus: '定位状态',
        clockInStatus: '打卡状态',
        callStatus: '通话状态',
        collectionActivity: '活跃度',
        collectionRecordCount: '催记数量',
        contactRate: '催收触达率',
        collectionRate: '催回率',
        lockFlag: '锁定开关',
        queryKeyword: '查询关键字',
        keywordInput: '请输入催收员登录账号',
        monitoringTotalMember: '监控成员总数',
        people: '人',
        onlineRate: '在线率',
        todayCallDuration: '今日通话时长',
        positionOffsetWarning: '位置偏移警告',
        anomaly: '处异常',
        currentLockUpPeriodTerminal: '当前锁定期终端',
        device: '台设备',
        collectionRank: '催收排名',
        detail: '详情',
        callRank: '通话排名',
        activityRank: '活跃排名',
        noData: '暂无数据',
        time: '次',
        configButton: '配置项',
        configManage: '配置项管理',
        configKey: '配置key',
        configvalue: '配置value',
        configRemark: '配置说明',
        configKeyInput: '请输入配置Key',
        configValueInput: '请输入配置value',
        configRemarkInput: '请输入配置说明',
        addConfig: '新增配置',
        editConfig: '编辑配置',
        collectionDetail: '催收排名详情',
        callRankDetail: '通话排名详情',
        activityRankDetail: '活跃排名详情',
        defaultRankDetail: '排名详情',
        activityMsg: '活跃度由每10分钟1个单元格，共计144个单元格组成。单元格的热力值由不同颜色代表：浅绿色-低，绿色-中低，黄色-中，橙色-中高，红色-高',
        activityTime: '活跃次数',
        addSuc: '新增成功',
        editSuc: '编辑成功',
        configKeyMsg: '配置Key不能为空',
        configValueMsg: '配置Value不能为空',
        lockSuc: '锁定成功',
        unLockSuc: '解锁成功',
        callTimes: '活跃数'



    },
    ti:{
        overdueTaskCount: 'จำนวนงานที่ค้างชำระ',
        otherCount: 'อื่น',
        borrowingCount: 'การยืม',
        noBorrowingCount: 'ไม่มีการยืม',
        loanCount: 'จำนวนเงินกู้',
        riskPassCount: 'จำนวนครั้งการควบคุมความเสี่ยงที่ผ่าน',
        applyCount: 'จำนวนใบสมัคร',
        registerCount: 'จำนวนการลงทะเบียน',
        invalidCount: 'ไม่ถูกต้อง',
        missedRejectedCount: 'พลาด ถูกปฏิเสธ',
        notCallCount: 'จำนวนสายที่ไม่ได้รับ',
        conversionRatio: 'อัตราส่วนการเปลี่ยนรูปแบบ',
        callCount: 'จำนวนสายที่เคยโทร',
        taskCountTotal: 'จำนวนงานทั้งหมด',
        dialDate: 'วันที่โทร',
        dialNumber: 'หมายเลขโทรออก',
        telemarketerName: 'ชื่อนักการตลาดทางโทรศัพท์',
        callStatus: 'สถานะการโทร',
        depositDate: 'วันที่ฝาก',
        batchReplacementFollowStaff: 'เปลี่ยนบุคลากรติดตามผลเป็นชุด',
        transferOrder: 'การปรับ',
        postTime: 'Splitting time',
        endDate: 'endDate',
        countDays: 'นับวัน',
        countDaysPlaceholder: 'กรุณาเลือกจำนวนวันที่นับ',
        statisticalPeriod: 'รอบสถิติ',
        userMobile: 'หมายเลขบัญชีพนักงานเก็บเงิน',
        userMobilePlaceholder: 'กรุณากรอกหมายเลขบัญชีพนักงานเก็บเงิน',
        viewField: 'แสดงฟิลด์',
        groupName: 'ชื่อกลุ่ม',
        collectionLevel: 'ขั้นตอนการเก็บเงิน',
        collectionLoginName: 'ชื่อบัญชีเข้าสู่ระบบ',
        collectionLoginNo: 'หมายเลขบัญชีล็อกอิน',
        locationStatus: 'สถานะตำแหน่ง',
        clockInStatus: 'สถานะการตอกบัตร',
        callStatus: 'สถานะการโทร',
        collectionActivity: 'กิจกรรม',
        collectionRecordCount: 'จำนวนการเร่งรัด',
        contactRate: 'อัตราการสัมผัสการเก็บรวบรวม',
        collectionRate: 'อัตราความสำเร็จในการเรียกเก็บเงิน',
        lockFlag: 'ล็อคธง',
        queryKeyword: 'คำค้นแบบสอบถาม',
        keywordInput: 'กรุณากรอกหมายเลขบัญชีล็อกอินพนักงานเก็บเงิน',
        monitoringTotalMember: 'ตรวจสอบสมาชิกทั้งหมด',
        people: 'คน',
        onlineRate: 'อัตราออนไลน์',
        todayCallDuration: 'ระยะเวลาในการโทรวันนี้',
        positionOffsetWarning: 'คำเตือนการชดเชยตำแหน่ง',
        anomaly: 'ค่าคงที่แตกต่างกัน',
        currentLockUpPeriodTerminal: 'สิ้นสุดระยะเวลาล็อคปัจจุบัน',
        device: 'จำนวนอุปกรณ์',
        collectionRank: 'การจัดอันดับการเก็บรวบรวม',
        detail: 'รายละเอียด',
        callRank: 'เรียกอันดับ',
        activityRank: 'การจัดอันดับที่ใช้งานอยู่',
        noData: 'ไม่มีข้อมูลในขณะนี้',
        time: 'เวลา',
        configButton: 'รายการการกำหนดค่า',
        configManage: 'การจัดการรายการการกำหนดค่า',
        configKey: 'ปรับแต่งคีย์',
        configvalue: 'กำหนดค่าค่า',
        configRemark: 'คำอธิบายการกำหนดค่า',
        configKeyInput: 'โปรดป้อนคีย์การกำหนดค่า',
        configValueInput: 'โปรดป้อนค่าการกำหนดค่า',
        configRemarkInput: 'โปรดป้อนคำอธิบายการกำหนดค่า',
        addConfig: 'การกำหนดค่าใหม่',
        editConfig: 'แก้ไขการกำหนดค่า',
        collectionDetail: 'รายละเอียดการจัดอันดับการเก็บรวบรวม',
        callRankDetail: 'รายละเอียดการจัดอันดับการโทร',
        activityRankDetail: 'รายละเอียดการจัดอันดับที่ใช้งานอยู่',
        defaultRankDetail: 'รายละเอียดการจัดอันดับ',
        activityMsg: 'กิจกรรมประกอบด้วย 1 เซลล์ทุก 10 นาทีรวม 144 เซลล์ ค่าความร้อนของเซลล์แสดงด้วยสีที่แตกต่างกัน: สีเขียวอ่อน - ต่ำ, สีเขียว - ต่ำ, สีเหลือง - กลาง, สีส้ม - กลางสูง, สีแดง - สูง',
        activityTime: 'จำนวนครั้งที่ใช้งาน',
        addSuc: 'เพิ่มข้อมูลสำเร็จ',
        editSuc: 'แก้ไขสำเร็จ',
        configKeyMsg: 'ปรับแต่งคีย์ให้ว่างเปล่าไม่ได้',
        configValueMsg: 'การกำหนดค่า Value ไม่สามารถว่างได้',
        lockSuc: 'ล็อคสำเร็จ',
        unLockSuc: 'ปลดล็อคความสำเร็จ',
        callTimes: 'จำนวนแอคทีฟ'
    },
    en: {
        overdueTaskCount: 'overdue Task Count',
        otherCount: 'No Borrowing Count',
        borrowingCount: 'Borrowing Count',
        noBorrowingCount: 'Other Count',
        loanCount: 'Loan Count',
        riskPassCount: 'Risk Pass Count',
        applyCount: 'Apply Count',
        registerCount: 'Register Count',
        callOutCount: 'Invalid Count',
        missedRejectedCount: 'Miss Rejected Count',
        notCallCount: 'Not Call Count',
        conversionRatio: 'Conversion Ratio',
        callCount: 'Call Count',
        taskCountTotal: 'Task Count Total',
        dialDate: 'Dial Date',
        dialNumber: 'Dial Number',
        telemarketerName: 'Telemarketer Name',
        callStatus: 'Call Status',
        depositDate: 'Deposit Date',
        title: 'Collection Management',
        allTitle: 'All Collection Tasks',
        mytitle: 'My Collection Tasks',
        historytitle: 'History Collection Tasks',
        performancetitle: 'Collection Performance',

        createTime: 'Created on',
        followNum: 'Follow number',
        followUserName: 'Persona a cargo',
        followResult: 'FollowResult',
        followTime: 'Follow Time',
        repaymentIntention: 'Repayment Intention',
        collectionTaskStatus: 'Task Statusa',
        batchReplacementFollowStaff: 'Batch Replacement Follow Staff',
        transferOrder: 'Transfer Order',
        userName: 'User Name',
        collectionNumber: 'Collection Number',
        collectionAmount: 'Collection Amount',
        pendingNum: 'Pending number',
        processNum: 'Process number',
        cancelNum: 'Cancel number',
        succedNumber: 'Succed Number',
        followCount: 'Follow Number',
        extendNumber: 'Extend Number',
        succedAmount: 'Succed Amount',
        succedRate: 'Succed Rate',
        approval: 'Approval',
        endTime: 'Due date',
        applyReductionAmt: 'apply reduction amount',
        balFee: 'balance late fee',
        countResult: 'Count Result',
        countResultRate: 'Count Result Rate',
        userId: 'user id',
        userMobile: 'user account',
        userMobilePlaceholder: 'Please input user account',
        groupName: 'group name',
        linkCondition: 'Contact Information Base',
        custContractCondition:'Customer contact information',
        amountSuccedRate: 'Amount Succed Rate',
        ym: 'ym',
        ifAmtRate: 'Amount rate',
        ifAmtFirstOverdueRate: 'Amount first overdue rate',
        ifAmtUnSettleRate: 'Amount unsettle rate',
        ifAmtEarlySettledRate: 'Amount early settled rate',
        ifAmtOverdueSettledRate: 'Amount overdue settled rate',
        ifAmtExtendsionSettledRate: 'Amount extendsion settled rate',
        ifAmtOverdueExtendsionSettledRate: 'Amount overdue extendsion settled rate',
        ifAmtSettledRate: 'Amount settled rate',
        ifLoanCount: 'Loan count',
        operationTime: 'operation Time',
        operationUserName: 'operation User Name',
        operationUserMobile: 'operation User Mobile',
        operationType: 'operationType',
        taskIdOld: 'taskId Old',
        taskIdNew: 'taskId New',
        orderInfoId: 'Order info id',
        custInfoId: 'Customer info id',
        waitingForCollection: 'Waiting For Collection',
        answeredByThemSelf: 'answered by them self',
        notInPerson: 'Not in person',
        noAnswer: 'no answer',
        emptyNumber: 'empty number',
        turnedOff: 'turned off',
        unavailable: 'unavailable',
        whatsappPromisesToPayBackOnTime: 'Whatsapp promises to pay back on time',
        WhatsappDidNotReply: 'Whatsapp did not reply',
        NoTieneCuentaDeWhatsapp: 'No tiene cuenta de whatsapp',
        haveAWishAndCanReturnTheLoan: 'have a wish and can return the loan',
        haveAWishButCantReturnTheLoan: `have a wish but can't return the loan`,
        canReturnTheLoanButRefuseToPayIt: 'can return the loan but refuse to pay it',
        canReturnTheLoanButWantToConsult: 'can return the loan but want to consult',
        cantJudgeItForNow: `can't judge it for now`,
        LaPersonaDeContactoPuedeComunicarleAlClienteParaElReembolso: 'The contact person can notify the customer of a refund ',
        ElContactoNoPuedeComunicarse: 'Contact person unable to communicate ',
        LaInformaciónDelContactoEsFalsa: 'The contact information is incorrect ',
        createdTime: 'Create Time',
        id: 'ID',
        remark: 'description',
        postTime: 'Splitting time',
        isFollow: 'Whether to follow up',
        isRegist: 'is Register',
        isApply: 'is Apply',
        isAudit: 'is Audit',
        endDate: 'endDate',
        countDays: 'count Days',
        countDaysPlaceholder: 'Please select count Days',
        statisticalPeriod: 'statistical Period',
        viewField: 'view Field',
        collectionLevel: 'collection level',
        collectionLoginName: 'collection login name',
        collectionLoginNo: 'collection login no',
        locationStatus: 'location status',
        clockInStatus: 'clock in status',
        callStatus: 'call status',
        collectionActivity: 'collection activity',
        collectionRecordCount: 'collection record count',
        contactRate: 'contact rate',
        collectionRate: 'collection rate',
        lockFlag: 'lock flag',
        queryKeyword: 'query keyword',
        keywordInput: 'Please input loginNo',
        monitoringTotalMember: '监控成员总数',
        people: 'person',
        onlineRate: 'online rate',
        todayCallDuration: 'today call duration',
        positionOffsetWarning: 'position offset warning',
        anomaly: 'anomalies',
        currentLockUpPeriodTerminal: 'current lock up period terminal',
        device: 'devices',
        collectionRank: 'collection Rank',
        detail: 'detail',
        callRank: 'call Rank',
        activityRank: 'activity Rank',
        noData: 'NO DATA',
        time: 'occurrences',
        configButton: 'config',
        configManage: 'config Manage',
        configKey: 'config Key',
        configvalue: 'config value',
        configRemark: 'config Remark',
        configKeyInput: 'Please input config key',
        configValueInput: 'Please input config value',
        configRemarkInput: 'Please input config remark',
        addConfig: 'add Config',
        editConfig: 'edit Config',
        collectionDetail: 'collection Detail',
        callRankDetail: 'callRank Detail',
        activityRankDetail: 'activityRank Detail',
        defaultRankDetail: 'defaultRank Detail',
        activityMsg: 'The activity level consists of 144 cells, with one cell every 10 minutes. The heat values of cells are represented by different colors: light green low, green medium low, yellow medium, orange medium high, red high',
        activityTime: 'activity Time',
        addSuc: 'add Successful',
        editSuc: 'edit Successful',
        configKeyMsg: 'config Key cannot be empty',
        configValueMsg: 'config value cannot be empty',
        lockSuc: 'lock success',
        unLockSuc: 'unlock success',
        callTimes: 'activity Times'
    }
}
